import type { CommandStatus } from '@bartizo/shared';
import type { ReactNode } from 'react';
import { STATUS_LABEL, STATUS_ORDER, STATUS_TONE } from '../lib/actions.js';

/** The non-zero counts, worst first: "1 failed · 3 done". */
export function ResultCounts({
  counts,
}: {
  counts: Partial<Record<CommandStatus, number>>;
}): ReactNode {
  const present = STATUS_ORDER.filter((status) => (counts[status] ?? 0) > 0);
  if (present.length === 0) return <span className="muted">no servers</span>;
  return (
    <span className="row">
      {present.map((status) => (
        <span key={status} className={`badge ${STATUS_TONE[status]}`}>
          {String(counts[status] ?? 0)} {STATUS_LABEL[status]}
        </span>
      ))}
    </span>
  );
}
